import { ThemeType } from './themeType';

export const darkTheme: ThemeType = {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    text: '#FFFFFF',
    widget_background: '#292929',
    widget_hover_background: '#484545',
    background_dashboard: '#131313',
    outline: '#3C3C3C',
    inactive: '#7D7D7D',
    // Colors
    red: '#FF4D42',
    main_cta: '#FFFF10',
    main_cta_light: 'rgb(255, 255, 16, 0.2)',
    green: '#53E8B2',
    salmon: '#FFCD83',
    light_yellow: '#FEFFC4',
    orange: '#F4B453',
    item_list_hover: 'linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #3C3C3C',
    surface_muted: '#3C3C3C',
    // Dark badges keep existing saturated Status colors (Status text stays black).
    badge_valid: '#53E8B2',
    badge_invalid: '#FF4D42',
    badge_risk_urgent: '#FF4D42',
    badge_risk_medium: '#F4B453',
    badge_risk_low: '#FEFFC4',
    hover_accent: '#FFFF10',
  },
  shadows: {
    glow: '0px 0px 35px rgba(255, 255, 16, 0.3)',
    dropdown: '0px 4px 20px rgba(0, 0, 0, 0.25)',
  },
  map: {
    commonGeometry: '#212121',
    commonTextFill: '#757575',
    administrative: '#757575',
    administrativeText: '#bdbdbd',
    administrativeCountry: '#9e9e9e',
    park: '#181818',
    parkText: '#616161',
    road: '#2c2c2c',
    roadText: '#8a8a8a',
    highWay: '#3c3c3c',
    highWayText: '#f3d19c',
    highWayControlled: '#4e4e4e',
    roadArterial: '#373737',
    roadLocal: '#616161',
    transit: '#757575',
    water: '#000000',
    waterText: '#3d3d3d',
  },
  // Preserve existing dark dashboard chart look (same as prior theme.colors mappings).
  charts: {
    alertImu: '#FFCD83',
    alertFrontCamera: '#FEFFC4',
    alertInwardCamera: '#FFFF10',
    alertCloud: '#FFFFFF',
    alertRiskUrgent: '#FF4D42',
    alertRiskMedium: '#F4B453',
    alertRiskLow: '#FEFFC4',
    deviceOnline: '#53E8B2',
    deviceOffline: '#FFFF10',
    deviceUnresponsive: '#FF4D42',
  },
};

// White/black are used both as literal colors (map strokes, control fills) and as
// contrast-pair text colors across ~100 files, so they stay literal in both themes -
// swapping them would break the map/canvas cases. Only the surface/border/semantic
// tokens change between themes.
// Light palette aligned to the dashboard mockup:
// page bg #F4F7F8, surfaces #FFFFFF, text #1A1A1A / #5F6368, accent cyan #00C2FF.
export const lightTheme: ThemeType = {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    text: '#1A1A1A',
    widget_background: '#FFFFFF',
    widget_hover_background: '#EEF1F3',
    background_dashboard: '#f0f5f5',
    outline: '#e4e6e8',
    inactive: '#5F6368',
    // Colors
    red: '#ff5246ff',
    main_cta: '#4fe5fa',
    main_cta_light: '#f6fcfdff',
    green: '#32f2b5ff',
    salmon: '#D98E3F',
    light_yellow: '#5ED4EF',
    orange: '#C97A1E',
    item_list_hover: 'linear-gradient(0deg, rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.03)), #FFFFFF',
    surface_muted: '#e4e6e8',
    // Soft badge tints so black Status text stays readable in light mode.
    badge_valid: '#6efebbff',
    badge_invalid: '#ff798bff',
    badge_risk_urgent: '#ff4860ff',
    badge_risk_medium: '#ffc593ff',
    badge_risk_low: '#a6f3ffff',
    hover_accent: '#5ED4EF',
  },
  shadows: {
    glow: '0px 0px 35px rgba(0, 194, 255, 0.22)',
    dropdown: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  },
  map: {
    commonGeometry: '#f6f6f4',
    commonTextFill: '#5F6368',
    administrative: '#15181aff',
    administrativeText: '#5F6368',
    administrativeCountry: '#5F6368',
    park: '#D5E8D8',
    parkText: '#5F7A62',
    road: '#FFFFFF',
    roadText: '#5F6368',
    highWay: '#D7E3EA',
    highWayText: '#5F6368',
    highWayControlled: '#C9D8E2',
    roadArterial: '#F4F7F8',
    roadLocal: '#5F6368',
    transit: '#8A939A',
    water: '#cad2d3',
    waterText: '#5A7180',
  },
  // Light dashboard chart colors from Alert types / Devices status mockup.
  charts: {
    alertImu: '#4fe5fa',
    alertFrontCamera: '#fda371',
    alertInwardCamera: '#71ffa1',
    alertCloud: '#C5CCD2',
    alertRiskUrgent: '#ff4869',
    alertRiskMedium: '#fda371',
    alertRiskLow: '#4fe5fa',
    deviceOnline: '#4fe5fa',
    deviceOffline: '#816cff',
    deviceUnresponsive: '#ff4869',
  },
};

// Backward-compatible default export - existing static `import { theme }` sites keep
// working (dark), while ThemeContext drives the live-switchable ThemeProvider value.
export const theme = darkTheme;
